import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        display: ", ";\n        flex: ", ";\n        flex-direction: ", ";\n        flex-wrap: ", ";\n        justify-content: ", ";\n        align-items: ", ";\n        padding: ", " ", ";\n        ", "\n        ", "\n        ", "\n        /* The Below is used for giving flex children a gap like css grid gap property */\n        & > * + * {\n          margin-top: ", ";\n          margin-left: ", ";\n        }\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'emotion';
import buildFlexProperties from './buildFlexProperties';

var FlexBox = function FlexBox(_ref) {
  var className = _ref.className,
      children = _ref.children,
      isInline = _ref.isInline,
      shouldWrap = _ref.shouldWrap,
      noGrow = _ref.noGrow,
      grow = _ref.grow,
      shrink = _ref.shrink,
      basis = _ref.basis,
      marginX = _ref.marginX,
      marginY = _ref.marginY,
      paddingX = _ref.paddingX,
      paddingY = _ref.paddingY,
      flexProperties = _objectWithoutProperties(_ref, ["className", "children", "isInline", "shouldWrap", "noGrow", "grow", "shrink", "basis", "marginX", "marginY", "paddingX", "paddingY"]);

  var _buildFlexProperties = buildFlexProperties(flexProperties),
      justifyContent = _buildFlexProperties.justifyContent,
      alignItems = _buildFlexProperties.alignItems;

  var layoutSizes = {
    xs: '0.25em',
    s: '0.5em',
    m: '0.75em',
    l: '1em',
    xl: '2em'
  };
  return React.createElement("div", {
    className: cx(css(_templateObject(), isInline ? 'inline-flex' : 'flex', noGrow ? '0 0 auto' : '1 1 auto', flexProperties.isVertical ? 'column' : 'row', shouldWrap ? 'wrap' : 'no-wrap', justifyContent, alignItems, layoutSizes[paddingX] || 0, layoutSizes[paddingY] || 0, grow !== undefined && "flex-grow: ".concat(grow, ";"), shrink !== undefined && "flex-shrink: ".concat(shrink, ";"), basis !== undefined && "flex-basis: ".concat(basis, ";"), flexProperties.isVertical && layoutSizes[marginY] || 0, !flexProperties.isVertical && layoutSizes[marginX] || 0), className)
  }, children);
};

FlexBox.defaultProps = {
  className: ''
};
FlexBox.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  isVertical: PropTypes.bool,
  isInline: PropTypes.bool,
  noGrow: PropTypes.bool,
  shouldWrap: PropTypes.bool,
  grow: PropTypes.number,
  shrink: PropTypes.number,
  basis: PropTypes.oneOf(PropTypes.number, 'auto'),
  top: PropTypes.bool,
  middle: PropTypes.bool,
  bottom: PropTypes.bool,
  left: PropTypes.bool,
  center: PropTypes.bool,
  right: PropTypes.bool,
  spaceBetween: PropTypes.bool,
  spaceAround: PropTypes.bool,
  marginY: PropTypes.oneOf('xs', 's', 'm', 'l', 'xl'),
  marginX: PropTypes.oneOf('xs', 's', 'm', 'l', 'xl'),
  paddingX: PropTypes.oneOf('xs', 's', 'm', 'l', 'xl'),
  paddingY: PropTypes.oneOf('xs', 's', 'm', 'l', 'xl')
};
export default FlexBox;